import React, { ReactNode } from "react";

import { Link } from "react-router-dom";

import { EntityType } from "@mapmycustomers/shared/enum";
import { Button } from "@mapmycustomers/ui";

import configService from "@app/config/ConfigService";
import Path from "@app/enum/Path";
import { EntityTypeSupportedInOverviewPreview } from "@app/scene/reports/types/EntityTypeSupportedInOverviewPreview";
import authService from "@app/store/auth/AuthService";
import { ClassName } from "@app/types/ui/ClassName";
import { getLegacyAppUrl } from "@app/util/appUrl";

interface BaseProps extends ClassName {
  children: ReactNode;
}

interface Props extends BaseProps {
  link: string;
}

export const LegacyLink: React.FC<Props> = ({ children, className, link }) => {
  const token = authService.getToken();
  if (!token) {
    return null;
  }

  return (
    <Button
      className={className}
      href={getLegacyAppUrl(configService.getBaseOldAppUrl(), token, link)}
      target="_blank"
      type="link"
    >
      {children}
    </Button>
  );
};

export const ModernLink: React.FC<Props> = ({ children, className, link }) => (
  <Link to={link}>
    <Button className={className} type="link">
      {children}
    </Button>
  </Link>
);

export const ViewAllLinkMap: Record<EntityTypeSupportedInOverviewPreview, React.FC<BaseProps>> = {
  [EntityType.ACTIVITY]: ({ children, ...props }: BaseProps) => (
    <ModernLink link={`${Path.ACTIVITY}/list`} {...props}>
      {children}
    </ModernLink>
  ),
  [EntityType.COMPANY]: ({ children, ...props }: BaseProps) => (
    <ModernLink link={Path.COMPANY} {...props}>
      {children}
    </ModernLink>
  ),
  [EntityType.DEAL]: ({ children, ...props }: BaseProps) => (
    <ModernLink link={Path.DEAL} {...props}>
      {children}
    </ModernLink>
  ),
  [EntityType.PERSON]: ({ children, ...props }: BaseProps) => (
    <ModernLink link={Path.PEOPLE} {...props}>
      {children}
    </ModernLink>
  ),
  [EntityType.ROUTE]: ({ children, ...props }: BaseProps) => (
    <LegacyLink link="/accounts/routing/list" {...props}>
      {children}
    </LegacyLink>
  ),
};
